import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import type { TipoSolicitacao } from '@/features/SI/models';
import { TIPO_SOLICITACAO_OPCOES } from '@/features/SI/pages/NovaSolicitacaoPage/novaSolicitacaoPage.definitions';
import { FILTRO_STATUS_OPCOES } from '../siSolicitacoesPage.definitions';
import type { FiltroSolicitacoes, FiltroStatusSolicitacoes } from '../siSolicitacoesPage.definitions';

interface SiSolicitacoesFiltrosProps {
  filtro: FiltroSolicitacoes;
  onChange: (filtro: FiltroSolicitacoes) => void;
}

const CAMPO_CLASSE =
  'rounded-full border border-raro-gray-200 bg-white py-2 text-sm text-raro-gray-700 shadow-sm focus:border-primary-300 focus:outline-none focus:ring-2 focus:ring-primary-100';

/** Busca + status + tipo, na mesma linha das abas "Minhas solicitações"/"Da minha equipe". */
export function SiSolicitacoesFiltros({ filtro, onChange }: SiSolicitacoesFiltrosProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <label className="relative min-w-[12rem] flex-1 sm:flex-none">
        <span className="sr-only">Pesquisar solicitações</span>
        <MagnifyingGlassIcon
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-raro-gray-400"
          aria-hidden="true"
        />
        <input
          type="search"
          value={filtro.texto}
          onChange={(event) => onChange({ ...filtro, texto: event.target.value })}
          placeholder="Pesquisar..."
          className={`${CAMPO_CLASSE} w-full pl-9 pr-3 sm:w-56`}
        />
      </label>
      <select
        aria-label="Status"
        value={filtro.status}
        onChange={(event) => onChange({ ...filtro, status: event.target.value as FiltroStatusSolicitacoes })}
        className={`${CAMPO_CLASSE} pl-3 pr-8`}
      >
        {FILTRO_STATUS_OPCOES.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor}>
            {opcao.label}
          </option>
        ))}
      </select>
      <select
        aria-label="Tipo"
        value={filtro.tipo}
        onChange={(event) => onChange({ ...filtro, tipo: event.target.value as TipoSolicitacao | '' })}
        className={`${CAMPO_CLASSE} pl-3 pr-8`}
      >
        <option value="">Todos os tipos</option>
        {TIPO_SOLICITACAO_OPCOES.map((opcao) => (
          <option key={opcao.value} value={opcao.value}>
            {opcao.label}
          </option>
        ))}
      </select>
    </div>
  );
}
